

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {StatusCarga} from '@/model/resource/StatusCarga'
import {StatusCargaCollection} from '@/model/collection/StatusCargaCollection'
import {ListStatusCargaSchema} from '@/schema/resource/StatusCarga/ListStatusCargaSchema'
import {CsvStatusCargaSchema} from '@/schema/resource/StatusCarga/CsvStatusCargaSchema'

@Component
export default class ListStatusCargaView extends Mixins(MixinQueryRouter) {
  schema = new ListStatusCargaSchema()
  collection = new StatusCargaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: StatusCarga) {
    Helper.pushByName('editStatusCarga', item.$id)
  }

  async removeItem(item: StatusCarga) {
    await new DialogRemove(item).confirm(() => item.removeStatusCarga())
    await this.collection.listStatusCarga()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new StatusCargaCollection().clearFilters().addFilter(params)

    await csv.listCsvStatusCarga()
    new CsvStatusCargaSchema().downloadCsv(csv.all())
  }
}
